import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import TextBox from '@components/TextBox/TextBox';
import FlightInfoRow from './FlightInfoRow/FlightInfoRow';
import * as actions from '@store/actions';
import ProgressBox from '@components/ProgressBox/ProgressBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AirportsModal from './AirportsModal/AirportsModal';
import MobileNav from '@components/Quoting/MobileNav/MobileNav';

const required = value => {
  if (value === null || !value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Please fill out this field.';
  }
};
const fieldValidator = {
  from: [required],
  to: [required],
  date: [required],
  time: [required],
  fromCode: [],
  toCode: [],
  roundtrip: [],
  id: []
};

class FlightInfo extends Component {
  constructor(props) {
    super(props);

    const legInfo = props.legInfo.map(leg => {
      leg.date = leg.date === null ? null : new Date(leg.date);
      const newLeg = {
        date: {
          visited: false,
          error: false,
          value: leg.date === null ? null : new Date(leg.date)
        },
        time: {
          visited: false,
          error: false,
          value: leg.time
        },
        from: {
          visited: false,
          error: false,
          value: leg.from
        },
        fromCode: leg.fromCode,
        to: {
          visited: false,
          error: false,
          value: leg.to
        },
        toCode: leg.toCode,
        roundtrip: leg.roundtrip,
        id: leg.id
      };
      return newLeg;
    });
    this.state = {
      legInfo: legInfo,
      modalActive: false,
      modalLegId: 1,
      modalFromTo: 'from',
      regions: ['United States', 'Canada', 'Mexico', 'International'],
      activeRegion: 'United States',
      activeState: 'Alabama',
      validation: []
    };
  }

  checkRoundtrip = legs => {
    for (let i = 0; i < legs.length; i++) {
      if (legs[i].roundtrip) {
        legs[i].from.value = legs[i - 1].to.value;
        legs[i].fromCode = legs[i - 1].toCode;
        legs[i].to.value = legs[i - 1].from.value;
        legs[i].toCode = legs[i - 1].fromCode;

        legs[i].from.visited = legs[i].to.visited = true;
        legs[i].from.error = legs[i].to.error = false;
      }
    }

    return legs;
  };
  onRoundtripChange = (event, legId) => {
    const legIndex = this.state.legInfo.findIndex(l => {
      return l.id === legId;
    });

    const legs = [...this.state.legInfo];
    legs[legIndex].roundtrip = !legs[legIndex].roundtrip;
    if (legs[legIndex].roundtrip === false) {
      legs[legIndex].from.value = legs[legIndex].to.value = '';
      legs[legIndex].from.visited = legs[legIndex].to.visited = true;
      legs[legIndex].from.error = legs[legIndex].to.error = false;
      legs[legIndex].fromCode = legs[legIndex].toCode = null;
    }

    this.setState({
      legInfo: this.checkRoundtrip(legs)
    });
  };

  onAutosuggestAirportSelect = (airport, legId, fromTo) => {
    const legIndex = this.state.legInfo.findIndex(l => {
      return l.id === legId;
    });

    const legs = [...this.state.legInfo];
    if (fromTo === 'from') {
      legs[legIndex].fromCode = airport.icaoCode;
      legs[legIndex].from.visited = true;
      legs[legIndex].from.error = false;
      legs[legIndex].from.value = airport.city + ' (' + airport.icaoCode + ')';
      if (airport.typePhenom === 'Prohibited Airport') {
        legs[legIndex].from.value += ' (P300 Only)';
      }
    } else {
      legs[legIndex].toCode = airport.icaoCode;
      legs[legIndex].to.visited = true;
      legs[legIndex].to.error = false;
      legs[legIndex].to.value = airport.city + ' (' + airport.icaoCode + ')';
      if (airport.typePhenom === 'Prohibited Airport') {
        legs[legIndex].to.value += ' (P300 Only)';
      }
    }

    this.setState({
      legInfo: this.checkRoundtrip(legs)
    });
  };

  onAirportSelect = airport => {
    const legIndex = this.state.legInfo.findIndex(l => {
      return l.id === this.state.modalLegId;
    });

    const legs = [...this.state.legInfo];
    if (this.state.modalFromTo === 'from') {
      legs[legIndex].fromCode = airport.icaoCode;
      legs[legIndex].from.value = airport.city + ' (' + airport.icaoCode + ')';
      legs[legIndex].from.visited = true;
      legs[legIndex].from.error = false;
      if (airport.typePhenom === 'Prohibited Airport') {
        legs[legIndex].from.value += ' (P300 Only)';
      }
    } else {
      legs[legIndex].toCode = airport.icaoCode;
      legs[legIndex].to.value = airport.city + ' (' + airport.icaoCode + ')';
      legs[legIndex].to.visited = true;
      legs[legIndex].to.error = false;
      if (airport.typePhenom === 'Prohibited Airport') {
        legs[legIndex].to.value += ' (P300 Only)';
      }
    }

    this.setState({
      legInfo: this.checkRoundtrip(legs),
      activeRegion: 'United States'
    });

    this.toggleModal();
  };

  toggleAirportsModal = (legId, fromTo) => {
    this.setState({
      modalLegId: legId,
      modalFromTo: fromTo
    });
    this.toggleModal();
  };

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current,
      activeRegion: 'United States'
    });

    if (!current) {
      this.props.getAirportsList(
        this.state.activeRegion,
        this.state.activeState
      );
    }
  };
  onDateChangeHandler = (date, itemId) => {
    const legIndex = this.state.legInfo.findIndex(l => {
      return l.id === itemId;
    });

    const legs = [...this.state.legInfo];
    legs[legIndex].date.value = date;
    legs[legIndex].date.visited = true;
    legs[legIndex].date.error = false;

    this.setState({
      legInfo: this.checkRoundtrip(legs)
    });
  };

  onTimeChangeHandler = (date, itemId) => {
    const legIndex = this.state.legInfo.findIndex(l => {
      return l.id === itemId;
    });

    const legs = [...this.state.legInfo];
    legs[legIndex].time.value = date;
    legs[legIndex].time.visited = true;
    legs[legIndex].time.error = false;

    this.setState({
      legInfo: this.checkRoundtrip(legs)
    });
  };

  onInputChangeHandler = (itemId, name, value) => {
    const legIndex = this.state.legInfo.findIndex(l => {
      return l.id === itemId;
    });
    const legs = [...this.state.legInfo];
    legs[legIndex][name].value = value;
    this.setState({
      legInfo: this.checkRoundtrip(legs)
    });
  };

  onAddFlightClick = () => {
    const noLegs = this.state.legInfo.length + 1;

    const newLeg = {
      from: {
        value: '',
        visited: false,
        error: false
      },
      fromCode: null,
      to: {
        value: '',
        visited: false,
        error: false
      },
      toCode: null,
      date: {
        value: null,
        visited: false,
        error: false
      },
      roundtrip: false,
      time: {
        value: '08:00',
        visited: false,
        error: false
      },
      id: noLegs
    };

    const legs = [...this.state.legInfo];
    legs.push(newLeg);

    this.setState({
      legInfo: this.checkRoundtrip(legs)
    });
  };

  onDeleteClickHandler = index => {
    const legs = this.state.legInfo.filter(obj => {
      return obj.id !== index;
    });

    const reorderedLegs = legs.map((item, index) => {
      item.id = index + 1;
      return item;
    });
    this.setState({
      legInfo: this.checkRoundtrip(reorderedLegs)
    });
  };

  onResetClick = () => {
    this.setState({
      legInfo: [
        {
          from: {
            value: '',
            visited: false,
            error: false
          },
          fromCode: null,
          to: {
            value: '',
            visited: false,
            error: false
          },
          toCode: null,
          date: {
            value: null,
            visited: false,
            error: false
          },
          roundtrip: false,
          time: {
            value: '08:00',
            visited: false,
            error: false
          },
          id: 1
        }
      ]
    });
    this.props.onReset();
  };

  onSubmit = () => {
    let validForm = true;
    const legInfo = JSON.parse(JSON.stringify(this.state.legInfo));

    for (let i = 0; i < legInfo.length; i++) {
      let objectToValid = legInfo[i];
      for (let index in objectToValid) {
        for (let k = 0; k < fieldValidator[index].length; k++) {
          objectToValid[index].visited = true;
          objectToValid[index].error = false;
          const validationMsg = fieldValidator[index][k](
            objectToValid[index].value
          );
          if (validationMsg !== undefined) {
            objectToValid[index].error = validationMsg;
            validForm = false;
          } else if (index === 'date' && i > 0) {
            if (
              new Date(objectToValid[index].value).getTime() <
              new Date(legInfo[i - 1].date.value).getTime()
            ) {
              objectToValid[index].error = 'Date must be after prior leg.';
              validForm = false;
            }
          }
        }
      }
    }

    if (validForm) {
      const toSubmit = legInfo.map(item => {
        item.from = item.from.value;
        item.to = item.to.value;
        item.date = item.date.value;
        item.time = item.time.value;
        return item;
      });
      this.props.onContinueClick(
        this.props.contractId,
        this.props.contractTypeId,
        toSubmit
      );
    } else {
      this.setState({
        legInfo: this.checkRoundtrip(legInfo)
      });
    }
  };

  onStateChange = state => {
    this.setState({
      activeState: state.value
    });

    this.props.getAirportsList(this.state.activeRegion, state.value);
  };

  onRegionChange = region => {
    this.setState({
      activeRegion: region
    });

    if (region === 'United States') {
      this.props.getAirportsList(region, this.state.activeState);
    } else {
      this.props.getAirportsList(region);
    }
  };

  render() {
    const resetButton = (
      <button
        onClick={this.onResetClick}
        className={
          this.props.isMobile
            ? 'btn btn-transparent btn-sm pt-2 mt-1'
            : 'btn btn-red float-right mr-5'
        }
      >
        Reset
      </button>
    );

    return (
      <React.Fragment>
        {this.props.isMobile && (
          <MobileNav
            {...this.props}
            title={'Flight Info'}
            rightButton={resetButton}
          />
        )}
        <TextBox
          header={
            this.props.isMobile ? (
              false
            ) : (
              <React.Fragment>
                Flight Info
                {resetButton}
              </React.Fragment>
            )
          }
          jsxHeader={true}
        >
          {this.props.loading && (
            <ProgressBox
              text={'Submitting ...'}
              icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
            />
          )}

          {this.props.error && (
            <div className={'alert alert-danger font-sm text-center p-0'}>
              {this.props.error}
            </div>
          )}
          {this.state.legInfo.map((item, index) => (
            <FlightInfoRow
              isMobile={this.props.isMobile}
              key={index}
              {...item}
              index={index + 1}
              previousDate={
                index > 0
                  ? this.state.legInfo[index - 1].date.value
                  : new Date()
              }
              lastLeg={this.state.legInfo.length === index + 1}
              onAutosuggestAirportSelect={(airport, legId, fromTo) =>
                this.onAutosuggestAirportSelect(airport, legId, fromTo)
              }
              deleteHandler={() => this.onDeleteClickHandler(item.id)}
              dateChangeHandler={date =>
                this.onDateChangeHandler(date, item.id)
              }
              timeChangeHandler={date =>
                this.onTimeChangeHandler(date, item.id)
              }
              inputChangeHandler={(name, value) =>
                this.onInputChangeHandler(item.id, name, value)
              }
              toggleAirportsModal={(itemId, fromTo) =>
                this.toggleAirportsModal(itemId, fromTo)
              }
              onRoundtripChange={event =>
                this.onRoundtripChange(event, item.id)
              }
            />
          ))}

          <Row>
            <Col className={this.props.isMobile ? 'text-center' : 'text-left'}>
              {this.state.legInfo.length < 4 ? (
                <button
                  className={'btn btn-red text-uppercase'}
                  onClick={this.onAddFlightClick}
                >
                  + Add a Leg
                </button>
              ) : (
                <div className={'font-sm color-red'}>
                  * For additional legs, please contact us directly by
                  calling&nbsp;&nbsp;
                  <a href={'tel:+18775199759'} className={'d-md-none red-link'}>
                    (877) 519-9759
                  </a>
                  <span className={'d-md-inline-block d-none'}>
                    (877) 519-9759
                  </span>
                  .
                </div>
              )}
            </Col>
          </Row>
        </TextBox>
        {!this.props.isMobile && (
          <button
            className="btn btn-transparent mt-2 float-left"
            onClick={this.props.prevClick}
          >
            <strong>
              <FontAwesomeIcon icon={['fas', 'chevron-left']} />
              &nbsp;&nbsp;Back
            </strong>
          </button>
        )}
        <button
          className={
            'btn btn-fullred mt-2 ' +
            (this.props.isMobile ? 'mx-auto d-block' : 'float-right')
          }
          onClick={this.onSubmit}
        >
          {this.props.contractVersion === 2 ? 'REQUEST TRIP' : 'REQUEST QUOTE'}
        </button>

        <AirportsModal
          {...this.state}
          isMobile={this.props.isMobile}
          toggleModal={this.toggleModal}
          onStateChange={state => this.onStateChange(state)}
          onRegionChange={state => this.onRegionChange(state)}
          onAirportSelect={airport => this.onAirportSelect(airport)}
          loading={this.props.airports.loading}
          airports={this.props.airports.airports}
          states={this.props.airports.states}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    contractId: state.auth.data.profile_ContractID,
    contractTypeId:
      state.auth.data.profile_ContractTypeID !== undefined
        ? state.auth.data.profile_ContractTypeID
        : null,
    contractVersion: state.auth.data.profile_ContractVersion,
    loading: state.flightInfo.loading,
    error: state.flightInfo.error,
    airports: state.airports,
    legInfo: state.flightInfo.legInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAirportsList: (region, state) =>
      dispatch(actions.airportsGetList(region, state)),
    onReload: () => dispatch(actions.quotingReload()),
    onContinueClick: (contractId, contractTypeId, flightData) =>
      dispatch(actions.quotingGetPrice(contractId, contractTypeId, flightData)),
    onReset: () => dispatch(actions.quotingReset())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlightInfo);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/FlightInfo/FlightInfo.jsx